import { ITimesTemp } from "@wind-log_library/fe-component-library";

export class ForecastDataModel {

    public actualData: number[];
    public ratedPower: number;
    public windlogData: ForecastWeatherProviderDataModel;
    public openWeatherData: ForecastWeatherProviderDataModel;
    public meteoBlueData: ForecastWeatherProviderDataModel;
    public tradingData: ForecastWeatherProviderDataModel;
    public meteologicaData: ForecastWeatherProviderDataModel;
    public dnv_forecaster: ForecastWeatherProviderDataModel;
    static mapData(data: any, level: string) {
        if (data && (ForecastDataModel.getLevelData(data, level))) {
            return new ForecastDataModel({
                ratedPower: (ForecastDataModel.getLevelData(data, level)).DATA.SNAPSHOT.DATA_30S.TURBINE.W_rated.value,
                actualData: (ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_10M.TURBINE.W_avg_mag_f.dataValue,
                windlogData: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.WIND_LOG, 'Wind-Log'),
                openWeatherData: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.OPEN_WEATHER, 'Open Weather'),
                meteoBlueData: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.METEOBLUE, 'Meteo Blue'),
                tradingData: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.TRADING, 'BKW Trading'),
                meteologicaData: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.METEOLOGICA, 'Meteologica'),
                dnv_forecaster: ForecastWeatherProviderDataModel.mapData((ForecastDataModel.getLevelData(data, level)).DATA.TIMESERIES.DATA_WFC.DNV_FORECASTER, 'DNV Forecaster')
            });
        } else {
            return null;
        }
    }

    constructor(init: Partial<ForecastDataModel>) {
        Object.assign(this, init);
    }

    private static getLevelData(data: any, level: string) {
        switch (level) {
            case 'portfolio': return data.PORTFOLIO;
            case 'country'  : return data.PORTFOLIO.COUNTRIES[0];
            case 'park'     : return data.PARKS[0];
            case 'turbine'  : return data.TURBINES[0];
        }

    }
}


export class ForecastWeatherProviderDataModel {

    public name: string;
    public weather: any[];
    public temperature: any[];
    public windSpeed: any[];
    public windDirection: any[];
    public theoreticalPower: any[];
    public theoreticalPowerAmended: any[];
    public negativeImbalance: any[];
    public positiveImbalance: any[];
    public revenueLosses: any[];

    static mapData(data: any, name: string) {
        if (data) {
            return new ForecastWeatherProviderDataModel({
                name,
                weather: data.weather ? data.weather.dataValue : [],
                temperature: data.temperature ? data.temperature.dataValue : [],
                windSpeed: data.windSpeed ? data.windSpeed.dataValue : [],
                windDirection: data.windDirection ? data.windDirection.dataValue : [],
                theoreticalPower: data.theoreticalPower?.dataValue,
                theoreticalPowerAmended: data.theoreticalPowerAmended?.dataValue,
                negativeImbalance: data.negativeImbalance ? data.negativeImbalance?.dataValue : [],
                positiveImbalance: data.positiveImbalance ? data.positiveImbalance?.dataValue : [],
                revenueLosses: data.revenues ? data.revenues.dataValue : []
            });
        } else {
            return null;
        }
    }

    constructor(init: Partial<ForecastWeatherProviderDataModel>) {
        Object.assign(this, init);
    }
}

export class ForecastWeatherDataReportModel {

    public rated: number;
    public weather: any[];
    public temperature: any[];
    public windSpeed: any[];
    public windDirection: any[];
    public theoreticalPower: any[];
    public theoreticalPowerAmended: any[];
    public timestamps: any[];

    static mapData(data: any, provider: string) {
        let providerQ;
        switch (provider) {
            case 'Wind-log':
                providerQ = 'WIND_LOG';
                break;
            case 'Meteo Blue':
                providerQ = 'METEOBLUE';
                break;
            case 'Open Weather':
                providerQ = 'OPEN_WEATHER';
                break;
        }
        if (data) {
            return new ForecastWeatherDataReportModel({
                rated: data.SNAPSHOT.DATA_30S.TURBINE.W_rated.value,
                weather: data.TIMESERIES.DATA_WFC[providerQ].weather.dataValue ? data.TIMESERIES.DATA_WFC[providerQ].weather.dataValue : [],
                temperature: data.TIMESERIES.DATA_WFC[providerQ].temperature ? data.TIMESERIES.DATA_WFC[providerQ].temperature.dataValue : [],
                windSpeed: data.TIMESERIES.DATA_WFC[providerQ].windSpeed ? data.TIMESERIES.DATA_WFC[providerQ].windSpeed.dataValue : [],
                windDirection: data.TIMESERIES.DATA_WFC[providerQ].windDirection ? data.TIMESERIES.DATA_WFC[providerQ].windDirection.dataValue : [],
                theoreticalPower: data.TIMESERIES.DATA_WFC[providerQ].theoreticalPower.dataValue,
                theoreticalPowerAmended: data.TIMESERIES.DATA_WFC[providerQ].theoreticalPowerAmended.dataValue,
                timestamps: data.TIMESERIES.DATA_WFC[providerQ].theoreticalPower.dataTimestamp
            });
        } else {
            return null;
        }
    }
    
    constructor(init: Partial<ForecastWeatherDataReportModel>) {
        Object.assign(this, init);
    }
}